import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData, TextInput } from '../../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class FullTeaserSplitBoxConverter extends CmsConverterService<FullTeaserSplitBoxData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      text: formData.st_text ?? defaultTextInput,
      link: {
        ...(formData.lt_button_link ?? defaultLinkData),
        show: !!formData.st_show_button?.value ?? false,
        text: formData.st_button_text?.value || formData.lt_button_link.text?.value || '',
        anchor: formData.st_button_anchor?.value || formData.lt_button_link?.anchor || '',
        name: formData.st_button_anchor?.value ? formData.st_button_anchor?.name : formData.st_button_text?.name || ''
      }
    }
  }
}

export const FULL_TEASER_SPLIT_BOX_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, FullTeaserSplitBoxData>>('FullTeaserSplitBoxConverter')

export interface FullTeaserSplitBoxData extends ConvertedComponentData {
  label: TextInput;
  headline: TextInput;
  text: TextInput;
  link: LinkData;
}
